import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})

export class ConfirmDialogComponent {
  @Input() message: string;
  @Input() isYesNo = false;
  @Input() displayImageUrl: string;
  @Input() closeAllWindows = false;
  @Input() noHpiStyle = false;

  constructor(public activeModal: NgbActiveModal) { }

  closeWindow(closeAll: boolean) {
    if (closeAll) {
      this.activeModal.close();
    } else {
      this.activeModal.dismiss();
    }
  }
}
